import { render, staticRenderFns } from "./ModuleHeader.vue?vue&type=template&id=2c49f74b&scoped=true"
import script from "./ModuleHeader.vue?vue&type=script&lang=js"
export * from "./ModuleHeader.vue?vue&type=script&lang=js"
import style0 from "./ModuleHeader.vue?vue&type=style&index=0&id=2c49f74b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c49f74b",
  null
  
)

export default component.exports